<template>
  <main id="app">
    <NuxtLoadingIndicator/>
    <VitePwaManifest/>
    <NuxtLayout>
      <NuxtPage/>
    </NuxtLayout>
    <ToastsToastContainer/>
  </main>
  <div id="teleports"/>
</template>